// Generated by GitHub Copilot
import React from "react";
import { Modal, Button, Spinner } from "react-bootstrap";

const DeleteConfirmModal = ({
  show,
  onHide,
  onConfirm,
  impactName,
  loading,
}) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton={!loading}>
        <Modal.Title>Confirm Deletion</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Are you sure you want to delete the impact record for{" "}
          <strong>{impactName}</strong>?
        </p>
        <p className="text-muted mb-0">This action cannot be undone.</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={loading}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirm} disabled={loading}>
          {loading ? (
            <>
              <Spinner size="sm" className="me-2" />
              Deleting...
            </>
          ) : (
            "Delete Impact"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteConfirmModal;
